import { jsx as l } from "react/jsx-runtime";
const c = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM8 13c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5Zm-.053-8.904c-1.57 0-2.505 1.064-2.505 2.322 0 .139.01.3.043.451l1.504.054a1.696 1.696 0 0 1-.032-.397c0-.505.366-1.011.99-1.011.623 0 .956.409.956.828 0 .279-.097.537-.387.752l-.548.409c-.612.462-.817 1.01-.817 1.515 0 .172.01.322.043.473h1.279c0-.484.258-.763.634-1.043l.409-.3c.645-.473 1.042-1.075 1.042-1.935 0-1.075-.87-2.118-2.612-2.118Zm-1.016 6.36 1.45-.389.387 1.449-1.449.388-.388-1.449Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  c as Help
};
